var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-mb-4"},[_c('div',{staticClass:"tw-flex tw-mb-4"},[_c('div',{staticClass:"tw-w-4 tw-h-4 tw-mr-4"},[_c('i',{class:`${_vm.icon}`,attrs:{"aria-hidden":"true"}})]),_c('p',{staticClass:"tw-font-bold tw-text-lg"},[_vm._v(_vm._s(_vm.label))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }